export default "__VITE_ASSET__DkDOYzMq__"